import React from 'react'

import { NoImageContent, RightImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const Notifications: React.FC<SectionProps> = ({ copy, topicKey }) => {
  const contentMap = {
    'notifications-overview': (
      <React.Fragment>
        <RightImageContent
          altImage={copy.notifications_overview.alt_image}
          content={
            <Text
              content={
                buildDynamicCopy(
                  copy.notifications_overview.widget_overview_instruction,
                  <b>{copy.notifications_overview.widget_overview_instruction_bold_1}</b>,
                  <b>{copy.notifications_overview.widget_overview_instruction_bold_2}</b>,
                ) as React.ReactNode
              }
            />
          }
          image={HELP_IMAGES.NOTIFICATIONS_OVERVIEW}
          sx={{ pt: 8 }}
        />
        <SectionTitle
          content={copy.notifications_overview.managing_notifications_section_title}
          sx={{ pt: 48 }}
        />
        <RightImageContent
          altImage={copy.notifications_overview.alt_image_managing_notifications}
          content={
            <React.Fragment>
              <List
                items={[
                  copy.notifications_overview.managing_notifications_list_1,
                  buildDynamicCopy(
                    copy.notifications_overview.managing_notifications_list_2,
                    <b>{copy.notifications_overview.managing_notifications_list_2_bold_1}</b>,
                  ) as React.ReactNode,
                ]}
                listType="ol"
                subItemPlacement={1}
                subItems={[
                  copy.notifications_overview.managing_notifications_list_sublist_1,
                  copy.notifications_overview.managing_notifications_list_sublist_2,
                  copy.notifications_overview.managing_notifications_list_sublist_3,
                ]}
                subListType="ul"
              />
            </React.Fragment>
          }
          image={HELP_IMAGES.NOTIFICATIONS_MANAGING}
        />
        <NoImageContent
          content={
            <React.Fragment>
              <SectionTitle content={copy.notifications_overview.notification_work_section_title} />
              <List
                items={[
                  buildDynamicCopy(
                    copy.notifications_overview.notification_work_list_1,
                    <b>{copy.notifications_overview.notification_work_list_1_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    copy.notifications_overview.notification_work_list_2,
                    <b>{copy.notifications_overview.notification_work_list_2_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    copy.notifications_overview.notification_work_list_3,
                    <b>{copy.notifications_overview.notification_work_list_3_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    copy.notifications_overview.notification_work_list_4,
                    <b>{copy.notifications_overview.notification_work_list_4_bold}</b>,
                  ) as React.ReactNode,
                ]}
              />
            </React.Fragment>
          }
          sx={{ pt: 48 }}
        />
        <NoImageContent
          content={
            <React.Fragment>
              <SectionTitle content={copy.notifications_overview.verify_email_section_title} />
              <List
                items={[
                  copy.notifications_overview.verify_email_list_1,
                  buildDynamicCopy(
                    copy.notifications_overview.verify_email_list_2,
                    <b>{copy.notifications_overview.verify_email_list_2_bold}</b>,
                  ) as React.ReactNode,
                ]}
              />
            </React.Fragment>
          }
          hasDivider={false}
          sx={{ pt: 48 }}
        />
      </React.Fragment>
    ),
  }
  return contentMap[topicKey as keyof typeof contentMap]
}

export default Notifications
